import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Button, Form, Input, message, Modal, Select, Spin } from 'antd'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  changeGroupForm,
  changePaginationGroupForm,
  createSellerGroup, editSellerGroup,
  fetchItemsForGroups, removeSellerGroup,
} from '../../../actions/sellerList'
import './index.less'
import useDebounce from '../../../shared/utils/useDebounce'

const storeKey = 'sellerList'


const GroupManagement = (props) => {
  const { getFieldDecorator, getFieldValue } = props.form
  const [selectSearch, setSelectSearch] = useState('')
  const debouncedSelectSearch = useDebounce(selectSearch, 700)

  const fetchItems = () => {
    const {
      page,
    } = props
    props.fetchItems({
      search: debouncedSelectSearch,
      page,
    })
  }

  const observer = useRef()

  const lastSellerElementRef = useCallback((node) => {
    if (props.sellerListGroupFormFetchItemsLoading) return
    if (observer.current) observer.current.disconnect()
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !props.sellerListGroupFormFetchItemsLoading && !props.sellerListGroupFormFetchItemsHasNoMore) {
        props.changePagination(props.page + 1)
        fetchItems()
      }
    })
    if (node) observer.current.observe(node)
  }, [props.sellerListGroupFormFetchItemsLoading, props.sellerListGroupFormFetchItemsHasNoMore])


  const createGroup = () => {
    props.createSellerGroup({
      groupSellers: getFieldValue('group_sellers'),
      groupName: getFieldValue('group_name'),
    })
  }

  const editGroup = () => {
    const { activeGroup } = props
    props.editSellerGroup({
      groupId: activeGroup,
      groupSellers: getFieldValue('group_sellers'),
    })
  }

  const handleOnSubmit = (e) => {
    e.preventDefault()
    props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return
      }
      if (props.type === 'create') {
        createGroup()
      } else {
        editGroup()
      }
    })
  }

  useEffect(() => {
    fetchItems()
  }, [debouncedSelectSearch])

  useEffect(() => {
    if (props.groupFormError) {
      message.error(props.groupFormError)
    }
  }, [props.groupFormError])

  useEffect(() => {
    fetchItems()
  }, [])


  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 7 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 12 },
      md: { span: 10 },
    },
  }

  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 12,
        offset: 7,
      },
    },
  }

  /**
     * Search of seller select handler.
     * @param value Value of search string.
     */
  const searchSeller = (value) => {
    props.changePagination(1)
    setSelectSearch(value)
  }

  const removeGroupHandler = (e) => {
    e.preventDefault()
    const handleOnOk = () => {
      props.removeSellerGroup({ id: props.activeGroup })
    }
    Modal.confirm({
      title: 'Удалить группу',
      content: 'Вы действительно хотите удалить группу?',
      okType: 'danger',
      okText: 'Да',
      cancelText: 'Нет',
      onOk() {
        handleOnOk()
      },
      onCancel() {
      },
    })
  }

  return (
    <Form onSubmit={handleOnSubmit}>
      <Form.Item label='Имя группы' {...formItemLayout}>
        {getFieldDecorator(
                    'group_name',
                    {
                        initialValue: props.groupName,
                        rules: [{
                            message: 'Пожалуйста, укажите имя группы',
                        }],
                    },
                )(<Input disabled={props.type === 'edit'} />)}
      </Form.Item>
      <Form.Item label='Торговые точки' {...formItemLayout}>
        {getFieldDecorator(
                    'group_sellers',
                    {
                        initialValue: props.type === 'create' ? [] : props.groupSellers.map(item => item.idnum),
                        rules: [{
                            message: 'Пожалуйста, выбирите торговые сети',
                            type: 'array',
                        }],
                    },
                )(<Select
                  mode='multiple'
                  style={{ width: '100%' }}
                  placeholder='Выберите торговые сети'
                  filterOption={false}
                  notFoundContent={<div />}
                  dropdownRender={menu => (
                    <div>
                      {menu}
                      <div className='group-manager_select-loading-wrapper'>
                        {props.sellerListGroupFormFetchItemsLoading &&
                        <Spin size='small' className='group-manager_select-loading' />}
                      </div>
                    </div>
                    )}
                  onSearch={searchSeller}
                >
                  {
                        props.groupSellers
                        &&
                        props.groupSellers.map(item => (
                          <Select.Option key={item.idnum} value={item.idnum}>
                            {item.s_name}
                          </Select.Option>
                        ))
                    }
                  {
                        props.sellerListGroupFormItems
                        &&
                        props.sellerListGroupFormItems
                            // If Fetch items which are already selected, skip them.
                            .filter(value => !props.groupSellers
                                    .map(seller => seller.idnum)
                                    .includes(value.idnum))
                            .map((item, index, arr) => (
                                index + 1 === arr.length
                                    ?
                                    (<Select.Option
                                      key={item.idnum}
                                      value={item.idnum}
                                    >
                                      <div ref={lastSellerElementRef}>
                                        {item.s_name}
                                      </div>
                                    </Select.Option>)
                                    :
                                    (<Select.Option key={item.idnum} value={item.idnum}>
                                      {item.s_name}
                                    </Select.Option>)
                            ))
                    }
                </Select>)}
      </Form.Item>
      <Form.Item {...tailFormItemLayout}>
        <Button
          type='primary'
          htmlType='submit'
          style={{ marginRight: '12px' }}
        >
          {props.type === 'create' ? 'Создать' : 'Сохранить'}
        </Button>
        {
                    props.type === 'edit'
                    &&
                    <Button
                      loading={props.isDeleteItemLoading}
                      type='danger'
                      htmlType='button'
                      onClick={removeGroupHandler}
                    >
                      Удалить
                    </Button>
                }
      </Form.Item>
    </Form>
  )
}

const CustomizedForm = Form.create({
  onFieldsChange(props, changedFields) {
    props.editGroupForm(changedFields)
  },
  mapPropsToFields(props) {
    const { groupsManagementFormFieldValues = {} } = props
    return {
      group_name: Form.createFormField(groupsManagementFormFieldValues.group_name),
      group_sellers: Form.createFormField(groupsManagementFormFieldValues.group_sellers),
    }
  },
})(GroupManagement)


const mapStateToProps = (state) => {
  const {
    sellerListGroupFormItems,
    sellerListGroupFormFetchItemsLoading,
    page,
    groupsManagementFormFieldValues,
    sellerListGroupFormFetchItemsHasNoMore,
    groupFormError,
  } = state[storeKey]
  return {
    groupFormError,
    sellerListGroupFormFetchItemsHasNoMore,
    groupsManagementFormFieldValues: groupsManagementFormFieldValues || {},
    sellerListGroupFormItems,
    sellerListGroupFormFetchItemsLoading,
    page: page || 1,
  }
}

const mapDispatchToProps = dispatch => ({
  editGroupForm: params => dispatch(changeGroupForm(params)),
  fetchItems: params => dispatch(fetchItemsForGroups(params)),
  changePagination: newPage => dispatch(changePaginationGroupForm(newPage)),
  editSellerGroup: params => dispatch(editSellerGroup(params)),
  createSellerGroup: params => dispatch(createSellerGroup(params)),
  removeSellerGroup: params => dispatch(removeSellerGroup(params)),
})
const DispatchedForm = withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomizedForm))

export default DispatchedForm



// WEBPACK FOOTER //
// src/containers/SellerList/GroupsManagement/index.jsx